<template>
  <div class="article-overview">
    <div class="overview-header">
      <img :src="aiAvatar" alt="" />
      <div class="overview-title">
        {{ $t(overviewTitle) }}
      </div>
      <a @click="handleClickOverview" v-if="!showedOverview">
        {{ $t('开始') }}
      </a>
    </div>
    <div v-if="showedOverview">
      <div class="overview-main">
        <div class="overview-line"></div>
        <p class="overview-content">
          <slot name="content"></slot>
        </p>
        <div class="overview-disclaimer" @click="handleClickDisclaimer">
          {{ $t('免责声明') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showMsg } from '@/plugins/msg'

export default {
  props: {
    overviewTitle: {
      type: String,
      required: true
    },
    content: {
      type: String
    },
    defaultShowedOverview: {
      type: Boolean,
      default: false
    },
    isTranslated: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showedOverview: this.defaultShowedOverview,

      // AI 头像
      AI_AVATARS: [
        'https://rongmai-oss.oss-cn-shenzhen.aliyuncs.com/ai-avatar.png',
        'https://rongmai-oss.oss-cn-shenzhen.aliyuncs.com/ai-avatar1.png',
        'https://rongmai-oss.oss-cn-shenzhen.aliyuncs.com/ai-avatar2.png',
        'https://rongmai-oss.oss-cn-shenzhen.aliyuncs.com/ai-avatar3.png',
        'https://rongmai-oss.oss-cn-shenzhen.aliyuncs.com/ai-avatar4.png',
        'https://rongmai-oss.oss-cn-shenzhen.aliyuncs.com/ai-avatar5.png',
        'https://rongmai-oss.oss-cn-shenzhen.aliyuncs.com/ai-avatar6.png',
        'https://rongmai-oss.oss-cn-shenzhen.aliyuncs.com/ai-avatar7.png'
      ]
    }
  },
  computed: {
    aiAvatar() {
      const index = +this.$route.query.aiAvatarIndex

      return this.AI_AVATARS[index] || this.AI_AVATARS[0]
    }
  },
  created() {},
  methods: {
    handleClickOverview() {
      this.showedOverview = true
      this.$emit('onShowOverview')
    },

    handleClickDisclaimer() {
      showMsg('newsDetail')
    }
  }
}
</script>

<style lang="scss" scoped>
.article-overview {
  background: var(--bg-color-10);
  box-shadow: 0 0 0 1px rgba(var(--font-color-3-rgb), 0.1);
  border-radius: 10px;
  padding: 12px 8px;
  font-size: 14px;
  line-height: 24px;

  .overview-line {
    margin: 10px 0;
    width: 100%;
    height: 1px;
    background: var(--border-color-6);
  }

  .overview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--font-color-1);
    position: relative;
    padding-left: 32px;

    img {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-55%);
      width: 30px;
      height: 30px;
    }

    .overview-title {
      font-weight: 600;
    }

    a {
      color: #2360ff;
      margin-right: 5px;
    }
  }

  .overview-main {
    color: var(--font-color-1);
    .overview-content {
      margin: 0 7px;
    }

    .overview-disclaimer {
      font-size: 13px;
      color: var(--font-color-3);
      text-decoration-line: underline;
      text-align: right;
      margin-right: 7px;
    }
  }
}
</style>
